module.exports = __webpack_public_path__ + "img/m5.f92e0e66.png";